















































































































































import Vue from 'vue'
import { cloneDeep } from 'lodash'
import { AdditionalField } from '@/model/additional-fields/AdditionalField'
import { DxHtmlEditor, DxToolbar, DxItem, DxTableContextMenu, DxMediaResizing } from 'devextreme-vue/html-editor'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { locale, loadMessages } from "devextreme/localization"
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'

interface LanguageListItem {
  id: number
  code: string
  text: string
}

interface ComponentData {
  multiLanguagesDialogData: LanguageListItem[]
  isTabs: boolean
  tab: number
  areaHeight: number
  sizeValues: any
  fontValues: any
  headerValues: any
  fontSizeOptions: any
  fontFamilyOptions: any
  headerOptions: any
}

export default Vue.extend({
  name: 'MultiLanguagesDialog',

  components: {
    DxHtmlEditor,
    DxMediaResizing,
    DxToolbar,
    DxTableContextMenu,
    DxItem
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    selectedField: {
      type: Object as () => AdditionalField
    },
    dialogData: Array as () => LanguageListItem[],
    isTextArea: Boolean,
    profitCenterMultiLanguageLoading: Boolean
  },

  data (): ComponentData {
    return {
      multiLanguagesDialogData: [],
      isTabs: false,
      tab: 0,
      areaHeight: 200,
      sizeValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
      fontValues: ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana'],
      headerValues: [false, 1, 2, 3, 4, 5],
      fontSizeOptions: { inputAttr: { 'aria-label': 'Font size' } },
      fontFamilyOptions: { inputAttr: { 'aria-label': 'Font family' } },
      headerOptions: { inputAttr: { 'aria-label': 'Font family' } },
    }
  },

  watch: {
    isTabs (newVal: boolean): void {
      if (newVal) {
        this.areaHeight = (this.$refs.cardText as HTMLElement).clientHeight - 72
      }
    },
  },

  computed: {
    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onSaveButtonClick (): void {
      this.$emit('saveMultiLanguageList', this.multiLanguagesDialogData)
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  mounted () {
    const app: any = document.getElementById("app")
    if(app) {
      app.style.zIndex = 500
    }
    this.multiLanguagesDialogData = cloneDeep(this.dialogData)
  },

  beforeDestroy (): void {
    const app: any = document.getElementById("app")
    if(app) {
      app.style.zIndex = ''
    }
  }
})
